import React from 'react';
import { Link } from 'react-router';

import './page-title-section.css';
import { PageTitleUnderlineExpression } from './page-title-underline-expression';

export const PageTitleSection = ({ title, introduction, showCTA = true }) => {
  const [firstWord, ...restOfTitle] = title.split(' ');

  return (
    <section className="page-title-section">
      <h1 className="page-title-section__title">
        <span className="page-title-section__title__first-word-container">
          <span className="page-title-section__title__first-word-container__word">
            {firstWord}
          </span>
          <PageTitleUnderlineExpression className="page-title-section__title__first-word-container__underline" />
        </span>{' '}
        {restOfTitle.join(' ')}
      </h1>

      <p className="page-title-section__text">{introduction}</p>

      {showCTA && (
        <Link to="/signup" className="page-title-section__cta">
          Sign up for free
        </Link>
      )}
    </section>
  );
};
